import { show } from '../actions/clearance_info_light_box_actions';
import { show as showFreeFitting } from '../actions/free_mobile_fitting_light_box_actions';

export default () => {
  const lightBoxes = document.querySelectorAll('.open-clearance-lightbox');
  const freeFittingBadges = document.querySelectorAll('.open-free-fitting-lightbox');
  lightBoxes.length &&
    lightBoxes.forEach((x) => {
      x.addEventListener('click', () => {
        show();
      });
    });
  freeFittingBadges.length &&
    freeFittingBadges.forEach((x) => {
      x.addEventListener('click', () => {
        showFreeFitting();
      });
    });
};
